<script lang="ts">
  import { getContext } from 'svelte'
  import { twMerge } from 'tailwind-merge'
  type TitleType = {
    id?: string
    title?: string
  }
  type DescType = {
    id?: string
    desc?: string
  }

  interface BaseProps {
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    role?: string
    color?: string
    withEvents?: boolean
    onclick?: (event: MouseEvent) => void
    onkeydown?: (event: KeyboardEvent) => void
    onkeyup?: (event: KeyboardEvent) => void
  }

  interface CtxType extends BaseProps {}
  interface Props extends BaseProps {
    title?: TitleType
    desc?: DescType
    ariaLabel?: string
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  }

  const ctx: CtxType = getContext('iconCtx') ?? {}
  const sizes = {
    xs: 'w-3 h-3',
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8'
  }

  export let size: Props['size'] = ctx.size || 'md'
  export let role: Props['role'] = ctx.role || 'img'
  export let color: Props['color'] = ctx.color || 'currentColor'
  //export let withEvents: Props['withEvents'] = ctx.withEvents || false
  export let title: TitleType = {}
  export let desc: DescType = {}

  let ariaDescribedby = `${title.id || ''} ${desc.id || ''}`
  let hasDescription = false

  $: if (title.id || desc.id) {
    hasDescription = true
  } else {
    hasDescription = false
  }
  export let ariaLabel = 'archive solid'
  export let strokeWidth = 2
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  {...$$restProps}
  class={twMerge('shrink-0', sizes[size ?? 'md'], $$props.class)}
  {role}
  aria-label={ariaLabel}
  aria-describedby={hasDescription ? ariaDescribedby : undefined}
  viewBox="0 0 16 16"
>
  {#if title.id && title.title}
    <title id={title.id}>{title.title}</title>
  {/if}
  {#if desc.id && desc.desc}
    <desc id={desc.id}>{desc.desc}</desc>
  {/if}
  <path
    d="m3 0.5h10c1.385 0 2.5 1.115 2.5 2.5v10c0 1.385-1.115 2.5-2.5 2.5h-10c-1.385 0-2.5-1.115-2.5-2.5v-10c0-1.385 1.115-2.5 2.5-2.5z"
    fill="#cbd6e8"
    stroke="#92a0ad"
  /><path
    d="m14.22 12.29q0 0.3326-0.04751 0.681-0.04751 0.3484-0.19 0.6335-0.1425 0.2851-0.3959 0.4751-0.2534 0.19-0.6651 0.19-0.5068 0-0.776-0.3167-0.2534-0.3167-0.3484-0.776-0.1584-0.7602-0.2059-1.52-0.03167-0.7602-0.06335-1.536-0.01584-0.776-0.07918-1.536-0.06335-0.7602-0.2534-1.52-0.1742 0.6018-0.3642 1.204-0.19 0.6018-0.4118 1.188-0.1742 0.4276-0.3484 0.871-0.1584 0.4276-0.2851 0.871-0.1109 0.3642-0.19 0.7443-0.07918 0.3801-0.1742 0.7443-0.03167 0.1425-0.09502 0.3642-0.06335 0.2059-0.1584 0.4276-0.07918 0.2217-0.1742 0.4118t-0.2059 0.2851q-0.2534 0.2217-0.6018 0.3009-0.3326 0.09502-0.6493 0.09502-0.5068 0-0.8077-0.3642-0.3009-0.3642-0.4434-0.8077-0.1109-0.3326-0.1742-0.6651-0.06335-0.3484-0.1425-0.681-0.2059-0.9027-0.4909-1.774-0.2692-0.871-0.5068-1.774-0.3167 0.7127-0.5701 1.425-0.2376 0.7127-0.3326 1.473-0.07918 0.5543-0.09502 1.124 0 0.5543-0.1425 1.109-0.1109 0.4118-0.3642 0.6335-0.2376 0.2376-0.681 0.2376-0.4118 0-0.681-0.1742-0.2692-0.1584-0.4276-0.4276-0.1584-0.2692-0.2217-0.6018-0.04751-0.3484-0.04751-0.6968 0-0.7443 0.19-1.584 0.19-0.8552 0.4593-1.71 0.2692-0.8552 0.5543-1.695 0.3009-0.8393 0.5226-1.568 0.2059-0.7127 0.3009-1.409 0.1109-0.6968 0.2692-1.409 0.06335-0.3009 0.2059-0.586 0.1584-0.3009 0.3642-0.5226 0.2217-0.2217 0.5068-0.3642 0.2851-0.1425 0.6176-0.1425 0.2376 0 0.4909 0.07918 0.2534 0.06335 0.4593 0.2059 0.2059 0.1267 0.3326 0.3326 0.1267 0.2059 0.1267 0.4909 0 0.2059-0.03167 0.4118-0.03167 0.19-0.03167 0.3959 0 1.742 0.2376 3.437 0.2375 1.695 0.7285 3.373 0.6493-1.489 1.093-3.041 0.4434-1.552 0.8552-3.12 0.1267-0.4593 0.2376-0.9344 0.1109-0.4751 0.3326-0.9185 0.2059-0.4118 0.5068-0.6651 0.3167-0.2692 0.7918-0.2692 0.2851 0 0.5701 0.06335 0.3009 0.04751 0.5385 0.19 0.2376 0.1267 0.3801 0.3642 0.1584 0.2217 0.1584 0.5701 0 0.2534-0.03167 0.5068-0.01584 0.2376-0.01584 0.4909 0 1.188 0.1425 2.376 0.1584 1.172 0.4276 2.344 0.2217 0.9977 0.3642 1.995 0.1584 0.9819 0.1584 1.995z"
    fill="#ff8c15"
  /></svg
>
